import { Box, Select, MenuItem, Pagination } from '@mui/material';
import { WsTypography, WsTypoColors, WsTypoVariants } from 'wisestep-base';

const WsDataGridPagination = ({ count, page, onPageChange, pageSize, onPageSizeChange }) => (
  <Box display="flex" alignItems="center" my={2}>
    <Box display="flex" alignItems="center">
      <WsTypography color={WsTypoColors.BLACK} variant={WsTypoVariants.SUB_TITLE}>
        Rows per page:
      </WsTypography>
      <Select
        value={pageSize ?? 15}
        onChange={onPageSizeChange}
        variant="outlined"
        size="small"
        sx={{
          marginLeft: 1,
          '& .MuiOutlinedInput-notchedOutline': {
            border: 'none',
          },
          '& .MuiSelect-select': {
            padding: '8px 16px',
          },
        }}
      >
        {[10, 15, 20, 25, 50, 75, 100].map((size) => (
          <MenuItem key={size} value={size}>
            {size}
          </MenuItem>
        ))}
      </Select>
    </Box>
    <Pagination
      count={count}
      page={page}
      onChange={onPageChange}
      showFirstButton
      showLastButton
      sx={{ marginLeft: 'auto' }}
    />
  </Box>
);
export default WsDataGridPagination;
